import APIModel from "../APIModel";

export default class EmailTemplates extends APIModel {
  private readonly resourceUrl: string;

  constructor() {
    super();
    this.resourceUrl = "notification_templates";
  }

  /* GET */

  async getData(params: object): Promise<any> {
    return await this.http.get(`${this.resourceUrl}`, params);
  }

  async getVariables(): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/variables`, {});
  }

  async getForEdit(id: number): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/${id}/edit`);
  }

  async getUsers(params: object): Promise<any> {
    return await this.http.get(`${this.resourceUrl}`, params);
  }

  /* POST */

  async edit(id: number, payload: object): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .post(`${this.resourceUrl}/${id}?_method=PATCH`, payload);
  }

  async sendEmail(
    userId: number,
    templateId: number | null,
    payload: object
  ): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .get(
        `notification_templates/${userId}/${templateId}/send_email`,
        payload
      );
  }

  /* PATCH */
}
